import styled from 'styled-components';

export const SummaryBlockWrapper = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
`;
